import { render } from "./ScheduledEmails.vue?vue&type=template&id=2d4ca253&scoped=true"
import script from "./ScheduledEmails.vue?vue&type=script&lang=js"
export * from "./ScheduledEmails.vue?vue&type=script&lang=js"

import "./ScheduledEmails.vue?vue&type=style&index=0&id=2d4ca253&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4ca253"]])

export default __exports__